import React from "react";
import "../styles/ReferralLandingPage.css";
import { useNavigate } from "react-router-dom";

const CALENDLY_URL = "https://calendly.com/aaron-s-pay2pee/30min";

export default function ReferralLandingPage() {
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const headerOffset = 84;
    const y = window.pageYOffset + el.getBoundingClientRect().top - headerOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const fireEvent = (name, params = {}) => {
    try {
      if (!window.gtag) return;
      window.gtag("event", name, {
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_name: "referral_program",
        ...params,
      });
    } catch {
      // no-op
    }
  };

  const navigate = useNavigate();

  const handleApply = () => {
    navigate("/referrals/apply");
  }

 
  
  const handleScheduleCall = () => {
    fireEvent("referral_schedule_click", {
      source: "landing",
      outbound: "calendly",
    });
    window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
  };
  subheadline:
"Refer qualified businesses to Pay2Pee and earn from real partner performance. Compensation is tied to verified activity, with milestone-based extensions as referred locations grow.";

  const programCards = [
    {
      title: "Who it’s for",
      text: "Promoters, influencers, nightlife professionals, local connectors, and anyone with access to business decision-makers.",
    },
    {
      title: "What you do",
      text: "Introduce qualified businesses that are a strong fit for Pay2Pee.",
    },
    {
      title: "How you earn",
      text: "Earn 10% of Pay2Pee’s platform earnings for each approved location you refer. Earnings begin once the location generates paid transactions.",
    },
  ];

  const howSteps = [
    {
      number: "01",
      title: "Submit a referral",
      text: "Send us a business that matches the Pay2Pee partner profile.",
    },
    {
      number: "02",
      title: "We review and onboard",
      text: "We handle partner qualification, outreach, and onboarding.",
    },
    {
      number: "03",
      title: "Earn as locations generate revenue",
      text: "Once a referred location begins processing paid transactions, you earn a percentage of Pay2Pee’s platform earnings tied to that location.",
    },
  ];

  const businessTypes = [
    "Bars and lounges",
    "Nightclubs",
    "Gas stations",
    "Convenience stores",
    "Event venues",
    "High-foot-traffic businesses",
  ];

  const advantages = [
    {
      title: "Built for qualified introductions",
      text: "This is designed for people with access to real business relationships, not broad affiliate traffic.",
    },
    {
      title: "Simple operating model",
      text: "You do not need to manage the entire sales process. A strong introduction can be enough to start the relationship.",
    },
    {
      title: "Aligned compensation",
      text: "Rewards are tied to real partner performance, helping keep the program sustainable and scalable.",
    },
    {
      title: "Strong market fit",
      text: "Pay2Pee offers businesses a new revenue opportunity from existing restroom demand and foot traffic.",
    },
    {
      title: "Multi-market potential",
      text: "Qualified referrers can introduce businesses across nightlife, events, and convenience retail.",
    },
    {
      title: "Professional and easy to follow",
      text: "The program is straightforward, easy to explain, and built for real-world local business introductions.",
    },
  ];
  
  <section className="rpSection rpSectionAlt">
  <div className="rpContainer">
    <div className="rpSectionHead">
      <h2 className="rpH2">Earnings & Milestones</h2>
      <p className="rpMuted">
        Referral earnings are tied to real partner activity and can extend as
        locations continue to perform.
      </p>
    </div>

    <div className="rpCardGrid rpCardGrid3">
      <div className="rpCard">
        <h3>Base Earnings</h3>
        <p>
          Earn 10% of Pay2Pee’s platform earnings for each approved location for
          the first 3 months.
        </p>
      </div>

      <div className="rpCard">
        <h3>Milestone Extensions</h3>
        <p>
          As referred locations generate consistent usage, your earning window
          can extend up to 12 months based on performance milestones.
        </p>
      </div>

      <div className="rpCard">
        <h3>Performance-Based Growth</h3>
        <p>
          Higher-performing locations unlock longer earning periods, rewarding
          quality referrals and strong business fit.
        </p>
      </div>
    </div>
  </div>
</section>

  const faqs = [
    {
      q: "Who can apply?",
      a: "The program is intended for connectors, promoters, influencers, nightlife professionals, and others with access to qualified local business relationships.",
    },
    {
      q: "What businesses are the best fit?",
      a: "The strongest referrals are bars, clubs, gas stations, convenience stores, event venues, and other businesses with restroom demand and consistent foot traffic.",
    },
    {
      q: "Do I need to close the deal myself?",
      a: "No. The program is built around qualified introductions. Pay2Pee handles follow-up, qualification, and onboarding.",
    },
    {
      q: "How does compensation work?",
      a: "Compensation is tied to approved partner activation and real partner performance. Depending on the referral and program terms, payouts may include milestone bonuses, ongoing performance-based rewards, or both.",
    },
    {
      q: "Can I refer more than one business?",
      a: "Yes. Referrers may submit multiple qualified businesses.",
    },
    {
        q: "How long do referral earnings last?",
        a: "Referral earnings begin with a 3-month window. As referred locations reach performance milestones based on usage and revenue, the earning period may extend up to 12 months.",
      }
  ];

  return (
    <main className="rp">
      <header className="rpTopbar">
        <div className="rpContainer rpTopbarInner">
          <div className="rpBrand">
            <img
              src="/images/logo.png"
              alt="Pay2Pee logo"
              className="rpBrandLogo"
            />
            <div>
              <div className="rpBrandName">Pay2Pee</div>
              <div className="rpBrandTag">Referral Program</div>
            </div>
          </div>

          <nav className="rpNav" aria-label="Referral navigation">
            <button type="button" className="rpNavLink" onClick={() => scrollToId("overview")}>
              Overview
            </button>
            <button type="button" className="rpNavLink" onClick={() => scrollToId("how")}>
              How it works
            </button>
            <button type="button" className="rpNavLink" onClick={() => scrollToId("faq")}>
              FAQ
            </button>
            <button type="button" className="rpBtn rpBtnGhost" onClick={handleApply}>
              Apply to Join
            </button>
          </nav>
        </div>
      </header>

      <section className="rpHero">
        <div className="rpContainer rpHeroGrid">
          <div className="rpHeroCopy">
            <div className="rpEyebrow">Enterprise Referral Program</div>

            <h1 className="rpH1">
              Refer qualified businesses to <span>Pay2Pee</span>
            </h1>

            <p className="rpSub">
              A professional referral program for connectors, promoters,
              influencers, nightlife operators, and local professionals who know
              businesses that can benefit from Pay2Pee.
            </p>

            <div className="rpCtas">
              <button
                type="button"
                className="rpBtn rpBtnPrimary"
                onClick={handleApply}
              >
                Apply to Join
              </button>

              <button
                type="button"
                className="rpBtn rpBtnSecondary"
                onClick={handleScheduleCall}
              >
                Schedule a Call
              </button>
            </div>

            <div className="rpMetaRow">
              <span className="rpMetaPill">Performance-based payouts</span>
              <span className="rpMetaPill">Milestone bonuses</span>
              <span className="rpMetaPill">Qualified partner referrals</span>
            </div>
          </div>

          <aside className="rpHeroPanel">
            <div className="rpPanel">
              <div className="rpPanelLabel">Program Summary</div>

              <div className="rpPanelItem">
                <div className="rpPanelKicker">Best Fit</div>
                <div className="rpPanelValue">
                  Bars, clubs, gas stations, venues, and high-traffic businesses
                </div>
              </div>

              <div className="rpPanelItem">
                <div className="rpPanelKicker">Program Type</div>
                <div className="rpPanelValue">
                  Business referral and partner growth program
                </div>
              </div>

              <div className="rpPanelItem">
                <div className="rpPanelKicker">Compensation</div>
                <div className="rpPanelValue">
                  Performance-based rewards tied to approved partner activity
                </div>
              </div>

              <div className="rpPanelDivider" />

              <button
                type="button"
                className="rpBtn rpBtnPrimary rpBtnFull"
                onClick={handleApply}
              >
                Apply now
              </button>

              <button
                type="button"
                className="rpBtn rpBtnSecondary rpBtnFull"
                onClick={handleScheduleCall}
              >
                Schedule a call
              </button>
            </div>
          </aside>
        </div>
      </section>

      <section className="rpSection rpSectionAlt" id="overview">
        <div className="rpContainer">
          <div className="rpSectionHead">
            <h2 className="rpH2">Program Overview</h2>
            <p className="rpMuted">
              A simple referral model built for qualified business introductions.
            </p>
          </div>

          <div className="rpCardGrid rpCardGrid3">
            {programCards.map((card) => (
              <div key={card.title} className="rpCard">
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rpSection" id="how">
        <div className="rpContainer">
          <div className="rpSectionHead">
            <h2 className="rpH2">How It Works</h2>
            <p className="rpMuted">
              The process is designed to stay simple, professional, and scalable.
            </p>
          </div>

          <div className="rpSteps">
            {howSteps.map((step) => (
              <div key={step.number} className="rpStep">
                <div className="rpStepNumber">{step.number}</div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rpSection rpSectionAlt">
        <div className="rpContainer">
          <div className="rpSectionHead">
            <h2 className="rpH2">Ideal Business Types</h2>
            <p className="rpMuted">
              The strongest referrals are businesses with restroom demand,
              consistent foot traffic, and decision-makers open to new revenue
              opportunities.
            </p>
          </div>

          <div className="rpBusinessGrid">
            {businessTypes.map((item) => (
              <div key={item} className="rpBusinessItem">
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rpSection">
        <div className="rpContainer">
          <div className="rpSectionHead">
            <h2 className="rpH2">Program Advantages</h2>
            <p className="rpMuted">
              Built to help serious connectors introduce real opportunities.
            </p>
          </div>

          <div className="rpCardGrid rpCardGrid3">
            {advantages.map((item) => (
              <div key={item.title} className="rpCard">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rpSection rpSectionAlt">
        <div className="rpContainer">
          <div className="rpSplit">
            <div className="rpSplitBox">
              <h2 className="rpH2">Why Businesses Join Pay2Pee</h2>
              <ul className="rpList">
                <li>Creates a new revenue stream from existing foot traffic</li>
                <li>Gives businesses control over restroom access</li>
                <li>Supports cleaner, more organized guest access</li>
                <li>Simple for operators to understand and test</li>
              </ul>
            </div>

            <div className="rpSplitBox">
            <h2 className="rpH2">How Compensation Works</h2>
<p className="rpMuted rpMutedBody">
  Referrers earn 10% of Pay2Pee’s platform earnings for each approved
  location they refer. Earnings begin once the location generates paid
  transactions.
</p>

<p className="rpMuted rpMutedBody">
  The initial earning window is 3 months. As referred locations reach
  performance milestones based on activity and revenue, the earning
  window can extend up to 12 months.
</p>
            </div>
          </div>
        </div>
      </section>

      <section className="rpSection" id="apply">
        <div className="rpContainer">
          <div className="rpApplyCard">
            <div className="rpApplyCopy">
              <div className="rpEyebrow">Apply</div>
              <h2 className="rpH2">Apply for the Pay2Pee Referral Program</h2>
              <p className="rpMuted rpMutedBody">
                If you know qualified businesses that are a fit for Pay2Pee,
                apply to join the program and start submitting referrals.
              </p>

              <ul className="rpList">
                <li>Built for qualified business introductions</li>
                <li>Simple application and review process</li>
                <li>Performance-based referral opportunity</li>
              </ul>
            </div>

            <div className="rpApplyActions">
              <button
                type="button"
                className="rpBtn rpBtnPrimary rpBtnFull"
                onClick={handleApply}
              >
                Apply now
              </button>

              <button
                type="button"
                className="rpBtn rpBtnSecondary rpBtnFull"
                onClick={handleScheduleCall}
              >
                Schedule a call
              </button>

              <div className="rpTiny">
                Applications are reviewed for fit. Calls are available for
                qualified referrers who want to learn more about the program.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rpSection rpSectionAlt" id="faq">
        <div className="rpContainer">
          <div className="rpSectionHead">
            <h2 className="rpH2">FAQ</h2>
          </div>

          <div className="rpFaq">
            {faqs.map((item) => (
              <details key={item.q} className="rpFaqItem">
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <footer className="rpFooter">
        <div className="rpContainer rpFooterInner">
          <div className="rpFooterBrand">
            <img
              src="/images/logo.png"
              alt="Pay2Pee logo"
              className="rpFooterLogo"
            />
            <div>
              <div className="rpBrandName">Pay2Pee</div>
              <div className="rpBrandTag">Referral Program</div>
            </div>
          </div>

          <div className="rpFooterLinks">
            <button type="button" className="rpFooterLink" onClick={() => scrollToId("overview")}>
              Overview
            </button>
            <button type="button" className="rpFooterLink" onClick={() => scrollToId("how")}>
              How it works
            </button>
            <button type="button" className="rpFooterLink" onClick={() => scrollToId("faq")}>
              FAQ
            </button>
            <button type="button" className="rpFooterLink" onClick={() => scrollToId("apply")}>
              Apply
            </button>
          </div>
        </div>
      </footer>
    </main>
  );
}